/*! @azure/msal-browser v3.21.0 2024-08-13 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.21.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
